<template>
  <b-overlay :show="formShow" rounded="sm" no-fade class=" mt-2">
    <b-card>
      <b-row>
        <table class="table table-sm">
          <thead>
            <tr>
              <th scope="col">User</th>
            </tr>
          </thead>
        </table>
      </b-row>

      <validation-observer ref="userRules">
        <b-form>
          <b-row class="mt-2">
            <!-- Name -->
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group>
                <label for="Name">Name</label>
                <validation-provider
                  name="name"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-input
                    id="name"
                    type="text"
                    v-model="userValue.name"
                  ></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- Surname -->
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label="Surname" label-for="surname">
                <validation-provider
                  name="surname"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-input
                    id="surname"
                    type="text"
                    v-model="userValue.surname"
                  ></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- Phone -->
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label="Phone" label-for="phone">
                <b-form-input
                  id="phone"
                  type="text"
                  v-model="userValue.phone"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <!-- Email -->
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label="Email" label-for="email">
                <validation-provider
                  name="email"
                  #default="{ errors }"
                  rules="required|email"
                >
                  <b-form-input
                    id="email"
                    type="text"
                    :disabled="userId > 0 && !$Can('edit_user_email')"
                    v-model="userValue.email"
                  ></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- Password -->
            <b-col cols="12" sm="6" md="4" xl="3" v-if="userValue.id == null">
              <b-form-group label="Password" label-for="password">
                <validation-provider
                  name="password"
                  #default="{ errors }"
                  rules="required"
                >
                  <b-form-input
                    id="password"
                    type="text"
                    v-model="userValue.password"
                  ></b-form-input>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="6" md="4" xl="3" v-else>
              <b-form-group label="Password" label-for="password">
                <b-form-input
                  id="password"
                  type="password"
                  v-model="userValue.password"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <!-- Field: Role -->
            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label="User Role" label-for="role">
                <validation-provider
                  name="role"
                  #default="{ errors }"
                  rules="required"
                >
                  <v-select
                    v-model="userValue.role"
                    :options="roleOptions"
                    :reduce="(val) => val.name"
                    label="name"
                    :clearable="false"
                    input-id="role"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label="Company" label-for="company">
                <validation-provider
                  name="company"
                  #default="{ errors }"
                  rules="required"
                >
                  <treeselect
                    ref="duplicateCompanies"
                    v-model="selectedCompany"
                    :multiple="false"
                    :reduce="(val) => val.id"
                    label="title"
                    @input="companyChanged"
                    :options="companies"
                    placeholder="Select Company"
                    required
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="12" md="12">
              <b-form-group label="Working Groups" label-for="working_group">
                <validation-provider name="working_group" #default="{ errors }">
                  <v-select
                    v-model="userValue.working_group_ids"
                    :reduce="(val) => val.id"
                    label="group_name"
                    limit="5"
                    :multiple="true"
                    :options="workingGroups"
                    :clearable="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- <b-col cols="12" sm="6" md="4" xl="3">
              <b-form-group label="Hired On" label-for="hired_on">
                <validation-provider
                  name="hired on"
                  #default="{ errors }"
                  rules="required"
                >
                  <flat-pickr
                    id="hired_on"
                    class="form-control"
                    :config="flatpickrConfig"
                    @input="dateChange"
                    placeholder="DD/MM/YYYY"
                    v-model="userValue.hired_on"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->

            <b-col cols="12" class="mt-5">
              <b-button
                v-if="userId == null"
                type="submit"
                @click.prevent="formSubmitted"
                variant="primary"
                class="mr-1 float-right"
              >
                Save
              </b-button>
              <b-button
                v-else
                type="submit"
                @click.prevent="formSubmitted"
                variant="primary"
                class="mr-1 float-right"
              >
                Save Changes
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BCol,
  BRow,
  BTab,
  BTabs,
  BCard,
  BAlert,
  BLink,
  VBModal,
} from "bootstrap-vue";
import { ref, onUnmounted } from "@vue/composition-api";
import flatPickr from "vue-flatpickr-component";

import store from "@/store";
import userStoreModule from "../userStoreModule";
import ImageCropper from "@core/components/image-cropper/ImageCropper.vue";
import { required, alphaNum, email } from "@validations";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import Cleave from "vue-cleave-component";
import "cleave.js/dist/addons/cleave-phone.us";
import router from "@/router";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axiosIns from "@/libs/axios";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
    BRow,
    BCol,

    vSelect,
    Cleave,
    ToastificationContent,
    ImageCropper,
    ValidationProvider,
    ValidationObserver,
    flatPickr,
    Treeselect,
  },

  directives: {
    Ripple,
    "b-modal": VBModal,
  },

  setup() {
    const USER_APP_STORE_MODULE_NAME = "user";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });
  },

  data: function() {
    var userValue = {
      name: null,
      surname: null,
      email: null,
      role: null,
      password: null,
      phone: null,
      status: "active",
      company_id: null,
      company: null,
      working_group_ids: [],
    };

    const statusOptions = [
      { label: "Active", value: "active" },
      { label: "Passive", value: "passive" },
    ];

    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      selectedCompany: null,
      userValue: userValue,
      originalEmail: null,
      baseURL: store.state.app.baseURL,
      required,
      alphaNum,
      email,
      roleOptions: [],
      companies: [],
      workingGroups: [],
      statusOptions,
      userId: null,
      formShow: false,
      flatpickrConfig: {
        dateFormat: "d/m/Y",

        enable: [
          {
            from: "01/01/2024",
            to: "31/12/2029",
          },
        ],
        disable: [
          function(date) {
            return date.getDay() === 0 || date.getDay() === 6;
          },
        ],

        locale: {
          firstDayOfWeek: 1,
        },
      },
    };
  },

  created() {
    this.getRoles();
    this.getCompanies();
    this.getWorkingGroups();
  },

  watch: {},

  methods: {
    dateChange() {},
    getRoles() {
      this.formShow = true;
      store
        .dispatch("user/fetchRoles")
        .then((res) => {
          this.roleOptions = res.data.data;

          let filteredRoles = res.data.data.filter(
            (role) => role.name !== "supermanager"
          );

          // Additional filtering based on user role
          if (
            this.userData.role !== "supermanager" &&
            this.userData.role !== "admin"
          ) {
            filteredRoles = filteredRoles.filter(
              (role) => role.name !== "admin"
            );
          }

          this.roleOptions = filteredRoles;
        })
        .catch((error) => {
          this.formShow = false;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "An error occurred",
              text: "Please try again later or contact support.",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },

    getCompanies() {
      store
        .dispatch("user/getAllCompanies")
        .then((res) => {
          this.companies = res.data.map((company) => ({
            id: company.id,
            label: company.title,
          }));
          this.getUserById();

          this.formShow = false;
        })
        .catch((error) => {
          console.log(error);
          this.$router.push({ name: "user-list" });
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "An error occurred",
              text: "Please try again later or contact support.",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        });
    },

    getWorkingGroups() {
      store
        .dispatch("user/getAllWorkingGroups")
        .then((res) => {
          this.workingGroups = res.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    companyChanged() {},

    getUserById() {
      if (router.currentRoute.params.id) {
        this.userId = parseInt(router.currentRoute.params.id);

        store
          .dispatch("user/fetchUser", { id: router.currentRoute.params.id })
          .then((res) => {
            this.userValue = res.data;
            this.originalEmail = this.userValue.email;

            this.selectedCompany = this.userValue.company.id;
            this.userValue.working_group_ids = res.data.working_groups.map(
              (group) => group.id
            );
          })
          .catch((error) => {
            this.formShow = false;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Error",
                text: error,
                icon: "XIcon",
                variant: "danger",
              },
            });
          });
      }
    },

    formSubmitted() {
      this.formShow = true;

      this.$refs.userRules.validate().then((success) => {
        if (success) {
          if (router.currentRoute.params.id) {
            this.userValue.company_id = this.selectedCompany;
            let userCheck = "no";

            if (this.originalEmail != this.userValue.email) {
              store
                .dispatch("user/userCheck", { email: this.userValue.email })
                .then((response) => {
                  userCheck = response.data;
                });
            }

            if (userCheck == "no") {
              store
                .dispatch("user/updateUser", this.userValue)
                .then((res) => {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: "Successful",
                      text: "✔️ User Update Successful",
                      icon: "ThumbsUpIcon",
                      variant: "success",
                    },
                  });
                  // this.formShow = false;
                  router.push({ name: "user-list" });
                })
                .catch((error) => {
                  console.log(error);
                  this.formShow = false;
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: "Error",
                      text:
                        "❌ Please try again or report an issue to support.",
                      icon: "XIcon",
                      variant: "danger",
                    },
                  });
                });
            } else {
              this.formShow = false;
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "This email address exists",
                  text: "Please enter another email address.",
                  icon: "RefreshCcwIcon",
                  variant: "warning",
                },
              });
            }
          } else {
            store
              .dispatch("user/userCheck", { email: this.userValue.email })
              .then((res) => {
                if (res.data == "no") {
                  this.userValue.company_id = this.selectedCompany;
                  store
                    .dispatch("user/addUser", this.userValue)
                    .then((res) => {
                      console.log(res.data);
                      this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: "Successful",
                          text: "✔️ User Add Successful",
                          icon: "ThumbsUpIcon",
                          variant: "success",
                        },
                      });
                      // this.formShow = false;
                      router.push({ name: "user-list" });
                    })
                    .catch((error) => {
                      console.log(error);
                      this.formShow = false;
                      this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: "Error",
                          text:
                            "❌ Please try again or report an issue to support.",
                          icon: "XIcon",
                          variant: "danger",
                        },
                      });
                    });
                } else {
                  this.formShow = false;
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: "This email address exists",
                      text: "Please enter another email address.",
                      icon: "RefreshCcwIcon",
                      variant: "warning",
                    },
                  });
                }
              })
              .catch((error) => {
                console.log(error);
                this.formShow = false;
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Error",
                    text: "❌ Please try again or report an issue to support.",
                    icon: "XIcon",
                    variant: "danger",
                  },
                });
              });
          }
        } else {
          this.formShow = false;
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
